<template>
  <div id="header">
    <div class="container">
      <div class="smuckers-logo__container">
        <a href="https://smuckerawayfromhome.com" data-gtmcat="OCS Engagement" data-gtmaction="click" data-gtmlabel="Logo">
          <img class="smuckers-logo" src="/AwayFromHome/Global/Logos/AFH-Primary-Logo.png" alt="Smucker Away From Home" />
        </a>
      </div>
      <div class="header__logos">
        <div class="header__logo">
          <img :src="`${assetPath}header-logos/folgers-header-logo.png`" width="122" height="76" alt="Folgers">
        </div>
        <div class="header__logo">
          <img :src="`${assetPath}header-logos/1850-header-logo.png`" width="122" height="76" alt="1850">
        </div>
        <div class="header__logo">
          <img :src="`${assetPath}header-logos/cafe-bustelo-header-logo.png`" width="122" height="76" alt="Café Bustelo">
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { assetPath } from './../../mixins/assetPath.js'



export default {
  name: 'Header',
  mixins: [assetPath]
}
  </script>
  <style lang="scss">
  #header {
    background-color: #fff;
    .container {
      display: flex;
      padding: 1em;
      .smuckers-logo__container{
        display: none;
        @media screen and (min-width: 768px){
          display: block;
          width: 75%;
          margin-right: 5%;
          .smuckers-logo {
            max-width: 120px;
            margin-left: 15px;
          }
        }
        
      }
      
      .header__logos {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        float: right;
        @media screen and (min-width: 768px){
          max-width: 364px;
        }
        
        .header__logo {
          text-align: center;
        }
      }
    }
  }
  

  </style>